import { getStatusBadge } from "@/components/table-utils/get-status-badge";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import AvatarCard from "@/ui/avatar-card";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Badge, Checkbox, Flex } from "rizzui";
import { UsersTableDataType } from ".";

const columnHelper = createColumnHelper<UsersTableDataType>();

export const usersColumns = [
    columnHelper.display({
        id: "select",
        size: 50,
        header: ({ table }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select all Rows"
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => table.toggleAllPageRowsSelected()}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select Row"
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        ),
    }),
    columnHelper.display({
        id: "id",
        size: 100,
        header: "User ID",
        cell: ({ row }) => <>#{row.original.id}</>,
    }),
    columnHelper.accessor("fullName", {
        id: "fullName",
        size: 300,
        header: "Name",
        enableSorting: false,
        cell: ({ row }) => (
            <AvatarCard
                src={row.original.avatar}
                name={row.original.fullName}
                description={row.original.email}
            />
        ),
    }),
    columnHelper.accessor("role", {
        id: "role",
        size: 150,
        header: "Role",
        cell: ({ row }) => row.original.role,
    }),
    columnHelper.accessor("createdAt", {
        id: "createdAt",
        size: 200,
        header: "Created",
        cell: ({ row }) => <DateCell date={new Date(row.original.createdAt)} />,
    }),
    columnHelper.display({
        id: "permissions",
        size: 250,
        header: "Permissions",
        cell: ({ row }) => (
            <Flex align="center" gap="2">
                {row.original.permissions.map((permission) => (
                    <Badge
                        rounded="lg"
                        key={permission}
                        variant="outline"
                        className="border-muted font-normal text-gray-500"
                    >
                        {permission}
                    </Badge>
                ))}
            </Flex>
        ),
    }),
    columnHelper.accessor("status", {
        id: "status",
        size: 150,
        header: "Status",
        enableSorting: false,
        cell: ({ row }) => getStatusBadge(row.original.status),
    }),
    columnHelper.display({
        id: "action",
        size: 140,
        cell: ({
            row,
            table: {
                options: { meta },
            },
        }) => (
            <TableRowActionGroup
                deletePopoverTitle={`Delete this user`}
                deletePopoverDescription={`Are you sure you want to delete this #${row.original.id} user?`}
                onDelete={() => meta?.handleDeleteRow?.(row.original)}
            />
        ),
    }),
];
